import React, { Component } from "react";

import appt from "../../_helpers/apptStatus";
import axiosInstance from "../../_helpers/axiosConfig";
import hasApptExpired from "../../_helpers/hasApptExpired";

import Accept from "../Accept/AcceptAppointmentPage";
import Loading from "../Utility/Loading";
import Confirmation from "../Confirmation/ConfirmationPage";

class RenderAppointmentStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: "",
      timezone: "",
      status: "",
      secondAppt: "",
      vaccine: ""
    };
  }

  componentDidMount() {
    axiosInstance
      .request({
        method: "GET",
        url: `/vaccine/appointment/${this.props.match.params.id}`,
      })
      .then((response) => {
        if (
          hasApptExpired(
            response.data.sentAt.date,
            response.data.sentAt.timezone
          ) === true
        ) {
          this.setState({ status: "expired" });
        }
        this.setState({
          date: response.data.firstAppt.date,
          name: response.data.firstName + " " + response.data.lastName,
          timezone: response.data.firstAppt.timezone,
          status: response.data.status,
          secondAppt: response.data.secondAppt,
          sentAtDate: response.data.sentAt.date,
          sentAtTimezone: response.data.sentAt.timezone,
          vaccine: response.data.vaccine
        });
      })
      .catch((error) => {
        if (error.response) {
          this.setState({
            status: error.response.status,
          });
        }
      });
  }

  render() {
    const id = this.props.match.params.id;
    const {
      date,
      name,
      timezone,
      secondAppt,
      status,
      sentAtDate,
      sentAtTimezone,
      vaccine
    } = this.state;

    return (
      <>
        {status === "pending" && (
          <Accept
            token={id}
            date={date}
            name={name.toLowerCase()}
            vaccine={vaccine}
            timezone={timezone}
            secondAppt={secondAppt}
            sentAtDate={sentAtDate}
            sentAtTimezone={sentAtTimezone}
          />
        )}
        {status === "scheduled" && <Confirmation {...appt.reserved} />}
        {status === "expired" && <Confirmation {...appt.unavailable} />}
        {status === 404 && <Confirmation {...appt.unavailable} />}
        {!status && <Loading />}
      </>
    );
  }
}

export default RenderAppointmentStatus;
